import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Card } from "antd";
import { useAssignments } from "../../../hooks/bot/useAssignments";
import AssignmentFilters from "../../../components/bot/assignments/AssignmentFilters";
import AssignmentsTable from "../../../components/bot/assignments/AssignmentsTable";
import BulkAssignmentModal from "./BulkAssignmentModal";
import AssignmentDetailsDrawer from "./AssignmentDetailsDrawer";

const AssignmentsManagement = () => {
  const location = useLocation();

  // Custom hook
  const {
    filteredAssignments,
    templates,
    loading,
    searchText,
    setSearchText,
    filterStatus,
    setFilterStatus,
    filterTemplate,
    setFilterTemplate,
    fetchAssignments,
    fetchTemplates,
  } = useAssignments();

  // Modal states
  const [studentsModalVisible, setStudentsModalVisible] = useState(false);
  const [detailsDrawerVisible, setDetailsDrawerVisible] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState(null);

  useEffect(() => {
    fetchTemplates();

    // Check if navigated from template with templateId in state
    if (location.state?.templateId) {
      setFilterTemplate(location.state.templateId);
    } else {
      // Initial fetch without filters
      fetchAssignments(filterStatus, filterTemplate);
    }
  }, []);

  useEffect(() => {
    fetchAssignments(filterStatus, filterTemplate);
  }, [filterStatus, filterTemplate, fetchAssignments]);

  const handleViewDetails = (assignment) => {
    setSelectedAssignment(assignment);
    setDetailsDrawerVisible(true);
  };

  return (
    <>
      <Card title="Student BOT Assignments">
        <AssignmentFilters
          searchText={searchText}
          onSearchChange={setSearchText}
          filterStatus={filterStatus}
          onStatusChange={setFilterStatus}
          filterTemplate={filterTemplate}
          onTemplateChange={setFilterTemplate}
          templates={templates}
          onStudentsAssignment={() => setStudentsModalVisible(true)}
        />

        <AssignmentsTable
          assignments={filteredAssignments}
          loading={loading}
          onViewDetails={handleViewDetails}
        />
      </Card>

      {/* Students Assignment Modal */}
      <BulkAssignmentModal
        visible={studentsModalVisible}
        onCancel={() => setStudentsModalVisible(false)}
        onSuccess={() => {
          setStudentsModalVisible(false);
          fetchAssignments(filterStatus, filterTemplate);
        }}
        templates={templates}
        preSelectedTemplate={filterTemplate}
      />

      {/* Assignment Details Drawer */}
      <AssignmentDetailsDrawer
        visible={detailsDrawerVisible}
        onClose={() => {
          setDetailsDrawerVisible(false);
          setSelectedAssignment(null);
        }}
        assignment={selectedAssignment}
        onUpdate={() => fetchAssignments(filterStatus, filterTemplate)}
      />
    </>
  );
};

export default AssignmentsManagement;
